import { gql } from '@apollo/client';

export const APPOINTMENT_CANCELLATION_REASONS = gql`
    query AppointmentCancellationReasons {
        optionValueSet(type: APPOINTMENT_CANCELLATION_REASON) {
            values {
                id
                name
                sortOrder
            }
        }
    }
`;
